var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BrowserEntryType, Button, filterBrowserEntriesByType, ListFileBrowser, translate, } from '@lucidlink/uicore';
import { PII_MASK_CLASS } from '#constants';
import { FileBrowserTestIdFactory } from '#interactions';
import { getSearchResultsLabel } from '../FileBrowser';
import { FsEntryPickerEmptyState, FsEntryPickerErrorState } from './components';
import { joinEntryPath } from './FsEntryPicker.services';
import { fsEntryPickerColumnConfig } from './fsEntryPickerColumnConfig';
import { FsEntryPickerTestIdFactory } from './interactions';
import { useFsEntryPicker } from './useFsEntryPicker';
// Links are never offered: no consumer can grant access to or share one
const FOLDER_ENTRY_TYPES = [
    BrowserEntryType.DIR,
];
const FOLDER_AND_FILE_ENTRY_TYPES = [
    BrowserEntryType.DIR,
    BrowserEntryType.FILE,
];
export const FsEntryPicker = ({ allowRootSelect = false, 'data-testid': testId, filespaceId, includeFiles = false, onSelect, SelectIcon, selectLabel, workspaceId, }) => {
    _react_refresh_temp_2();
    const { changeCurrentDir, crumbs, currentDirId, currentDirPath, currentDirSelection, entries, isCrumbsError, isCrumbsPending, isFilespaceError, isInRoot, isLoading, isNavigationError, isRetrying, retry, search, setSearch, } = useFsEntryPicker({ filespaceId, workspaceId });
    const columnConfig = useMemo(() => fsEntryPickerColumnConfig({
        onEntrySelect: ({ id, name, type }) => onSelect({
            id,
            name,
            path: joinEntryPath(currentDirPath, name),
            type,
        }),
        SelectIcon,
        selectLabel,
        testId,
    }), [currentDirPath, onSelect, SelectIcon, selectLabel, testId]);
    const entryTypes = includeFiles
        ? FOLDER_AND_FILE_ENTRY_TYPES
        : FOLDER_ENTRY_TYPES;
    const searchResultsLabel = getSearchResultsLabel({
        noResultsLabel: includeFiles
            ? translate('No matching files or folders')
            : translate('No matching folders'),
        resultsCount: search.trim() === ''
            ? undefined
            : filterBrowserEntriesByType(entries, entryTypes).length,
    });
    const errorState = (_jsx(FsEntryPickerErrorState, { "data-testid": FileBrowserTestIdFactory.getRetryTestId(testId), isRetrying: isRetrying, onRetry: retry }));
    if (isFilespaceError) {
        return errorState;
    }
    const canSelectCurrentDir = currentDirSelection !== undefined && (allowRootSelect || !isInRoot);
    return (_jsx(ListFileBrowser, { breadcrumbClassName: PII_MASK_CLASS, breadcrumbErrorLabel: translate('Failed to load the folder path'), breadcrumbMenuButtonLabel: translate('Show parent folders'), breadcrumbsHeaderActions: canSelectCurrentDir && (_jsx(Button, { "data-testid": FsEntryPickerTestIdFactory.getCurrentDirSelectTestId(testId), kind: "primary", onClick: () => onSelect(currentDirSelection), size: "small", ...(SelectIcon && { StartIcon: SelectIcon }), children: selectLabel })), columnConfigList: columnConfig, crumbs: crumbs, currentDirId: currentDirId, "data-testid": FileBrowserTestIdFactory.getBrowserTestId(testId), emptyState: _jsx(FsEntryPickerEmptyState, { "data-testid": FileBrowserTestIdFactory.getEmptyStateTestId(testId), includeFiles: includeFiles, isFiltered: search !== '' || entries.length > 0 }), entries: entries, entryTypes: entryTypes, errorState: errorState, isBreadcrumbError: isCrumbsError, isBreadcrumbLoading: isCrumbsPending, isBreadcrumbsHeaderActive: true, isFiltersHeaderActive: true, isLoading: isLoading, isNavigationError: isNavigationError, loadingLabel: translate('Loading folder contents'), onDirOpen: changeCurrentDir, search: search, searchAriaLabel: translate('Search by filename or extension'), searchCloseLabel: translate('Clear search'), searchPlaceholder: translate('Search by filename or extension'), searchResultsLabel: searchResultsLabel, setSearch: setSearch }));
};
_react_refresh_temp_1 = FsEntryPicker;
$RefreshReg$(_react_refresh_temp_1, "FsEntryPicker");
_react_refresh_temp_2(FsEntryPicker, "1aMU1gyXkmGoH2lDphyhxqyi8QM=", false, () => [useFsEntryPicker]);
